import React, { createContext, useState, useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { baseThemeOptions } from "../theme/base-theme-options";
import { lightThemeOptions } from "../theme/light-theme-options";
import { darkThemeOptions } from "../theme/dark-theme-options";

import { deepmerge } from "@mui/utils";

export const ColorModeContext = createContext();

const ColorModeProvider = ({ children }) => {
  const [mode, setMode] = useState("light");
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        // setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );
  const theme =
    mode === "light"
      ? createTheme(deepmerge(darkThemeOptions, baseThemeOptions))
      : createTheme(deepmerge(lightThemeOptions, baseThemeOptions));

  return (
    <ColorModeContext.Provider value={{ theme, colorMode }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default ColorModeProvider;
// export const useThemeProvider = () => useContext(ThemeContext);
